const SvgHomeHero = (props) => (
  <svg viewBox="0 0 780 390" xmlns="http://www.w3.org/2000/svg">
    <path d="M467 130v259H209l258-259Z" fill="#29A964" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M274.544 322.884c15.783 15.783 37.587 25.545 61.67 25.545 48.167 0 87.214-39.047 87.214-87.214 0-24.084-9.761-45.888-25.544-61.67l-123.34 123.339Z"
      fill="#EFAC26"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M422.391 247.718c-2.902-18.679-11.733-35.399-24.507-48.173L274.545 322.884C258.762 307.102 249 285.298 249 261.214 249 213.047 288.047 174 336.214 174c43.577 0 79.689 31.96 86.177 73.718Z"
      fill="#F06C22"
    />
    <path fill="#3763FF" d="M467 130h258v259H467z" />
    <path d="M544 234.5c0-28.995 23.505-52.5 52.5-52.5s52.5 23.505 52.5 52.5V390H544V234.5Z" fill="#FCFCFC" />
    <path fill="#D3DDFF" d="M725 289h55v100h-55zM598 289h56v100h-56z" />
    <path fill="#2525D7" d="M649 289h76v100h-76z" />
    <circle cx={144} cy={325} r={65} fill="#BC6038" />
    <circle cx={632} cy={65} r={65} fill="#F2D6BB" />
    <path d="M33.59 337 66 389H0l33.59-52Z" fill="#3763FF" />
  </svg>
);

export default SvgHomeHero;
